export default {
  subDomain: 'admin.alianza.com',
  mainColor: '#0072BC',
  primaryColor: '#61a2d8',
  secondaryColor: '#3b7db6',
  titleText: 'test',
  linkColor: '#0072bc'
}



// WEBPACK FOOTER //
// ./src/lib/defaultBranding.js